import { EventDrivenStore } from '@core/store/eventDrivenStore';
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';

class ProfileStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      loading: false,
      error: null,
      currentMonthOrders: 0,
      userProfileLevel: null
    };
    super('profile', initialState);
  }

  async setupEvents() {
    // Listen for order stats updates
    this.on(constants.EVENTS.ORDERS.STATS_UPDATED, (stats) => {
      this.state.currentMonthOrders = stats?.currentMonthOrders || 0;
    });

    // Listen for user level updates from rewards
    this.on(constants.EVENTS.REWARDS.LEVEL_UPDATED, (levelData) => {
      this.state.userProfileLevel = levelData;
    });

    // Fetch profile data on mount
    this.on(constants.EVENTS.PROFILE.LOAD_DATA, async () => {
      await this.fetchProfileData();
    });
  }

  async fetchProfileData() {
    this.state.loading = true;
    this.state.error = null;

    try {
      // Emit events to fetch related data
      bus.emit(constants.EVENTS.ORDERS.FETCH_STATS);
      bus.emit(constants.EVENTS.REWARDS.FETCH_USER_LEVEL);

      this.state.loading = false;
    } catch (error) {
      this.state.error = error?.message || 'Failed to load profile data';
      this.state.loading = false;
    }
  }
}

export default ProfileStore;
